// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"0a68e2b2","192":"9baada3a","563":"c338f667","632":"c925e6af","703":"cd15264a","732":"8d77b302","765":"d12a68f9","989":"b5e64be5"}[chunkId] + ".chunk.css";
};